exports.partial = require('./partial')
exports.PLACEHOLDER = require('./PLACEHOLDER')
exports.set_function_arity = require('./set_function_arity')
exports.set_function_name = require('./set_function_name')
exports.set_function_name_and_arity = require('./set_function_name_and_arity')
